"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsonld_context_parser_1 = require("jsonld-context-parser");
/**
 * Utility functions and methods.
 */


var Util =
/*#__PURE__*/
function () {
  function Util() {
    _classCallCheck(this, Util);
  }

  _createClass(Util, null, [{
    key: "termToValue",

    /**
     * Convert an RDF term to a JSON value.
     * @param {Term} term An RDF term.
     * @param {IJsonLdContextNormalized} context The context.
     * @param {ITermToValueOptions} options Conversion options.
     * @return {any} A JSON value.
     */
    value: function termToValue(term, context) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        compactIds: false,
        useNativeTypes: false
      };

      switch (term.termType) {
        case 'NamedNode':
          var compacted = jsonld_context_parser_1.ContextParser.compactIri(term.value, context, options.vocab);
          return options.compactIds ? compacted : {
            '@id': compacted
          };

        case 'DefaultGraph':
          return options.compactIds ? term.value : {
            '@id': term.value
          };

        case 'BlankNode':
          var id = "_:".concat(term.value);
          return options.compactIds ? id : {
            '@id': id
          };

        case 'Literal':
          var stringType = term.datatype.value === Util.XSD_STRING;
          var rawValue = {
            '@value': !stringType && options.useNativeTypes ? Util.stringToNativeType(term.value, term.datatype.value) : term.value
          };

          if (term.language) {
            return Object.assign({}, rawValue, {
              '@language': term.language
            });
          } else if (!stringType && typeof rawValue['@value'] === 'string') {
            return Object.assign({}, rawValue, {
              '@type': term.datatype.value
            });
          } else {
            return rawValue;
          }

      }
    }
    /**
     * Convert a string term to a native type.
     * If no conversion is possible, the original string will be returned.
     * @param {string} value An RDF term's string value.
     * @param {string} type
     * @return {any}
     */

  }, {
    key: "stringToNativeType",
    value: function stringToNativeType(value, type) {
      if (type.startsWith(Util.XSD)) {
        var xsdType = type.substr(Util.XSD.length);

        switch (xsdType) {
          case 'boolean':
            if (value === 'true') {
              return true;
            } else if (value === 'false') {
              return false;
            }

            throw new Error("Invalid xsd:boolean value '".concat(value, "'"));

          case 'integer':
          case 'number':
          case 'int':
          case 'byte':
          case 'long':
            var parsedInt = parseInt(value, 10);

            if (isNaN(parsedInt)) {
              throw new Error("Invalid xsd:integer value '".concat(value, "'"));
            }

            return parsedInt;

          case 'float':
          case 'decimal':
          case 'double':
            var parsedFloat = parseFloat(value);

            if (isNaN(parsedFloat)) {
              throw new Error("Invalid xsd:float value '".concat(value, "'"));
            }

            return parsedFloat;
        }
      }

      return value;
    }
  }]);

  return Util;
}();

Util.XSD = 'http://www.w3.org/2001/XMLSchema#';
Util.XSD_STRING = Util.XSD + 'string';
Util.RDF = 'http://www.w3.org/1999/02/22-rdf-syntax-ns#';
Util.RDF_TYPE = Util.RDF + 'type';
exports.Util = Util;